import { createAction, props } from '@ngrx/store';

export const setLanguage = createAction('[Global] Set Language', props<{ language: string }>());

export const setTheme = createAction('[Global] Set Theme', props<{ theme: string }>()); 
